import { InputV2 } from '@cimplico/components';
import { useFirmEntryDescriptions } from '../../../queries/use-firm-entry-descriptions';

type EntryDescriptionInputProps = {
    value?: string;
    onChange: (value: string) => void;
};

function EntryDescriptionSelect({ value, onChange }: EntryDescriptionInputProps): JSX.Element {
    const entryDescriptionsQuery = useFirmEntryDescriptions();

    return (
        <InputV2
            type="text"
            placeholder="Description..."
            onChange={onChange}
            value={value}
            options={entryDescriptionsQuery.data?.entryDescriptions?.map((d) => d.description) || []}
            autoFocus
        />
    );
}

export default EntryDescriptionSelect;
